import { render, staticRenderFns } from "./markdown-component.vue?vue&type=template&id=dee8dea2"
import script from "./markdown-component.vue?vue&type=script&lang=js"
export * from "./markdown-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports